import { PersonalInfoService } from './personal-info.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css']
})
export class PersonalInfoComponent implements OnInit {

  public todayDate: Date;
  constructor(private personalInfoService: PersonalInfoService, private router: Router) { }

  ngOnInit(): void {

    this.todayDate = new Date()
  }

  onSubmit(data) {
    // console.warn("==================== data :: ", data)
    // this.payload = [data]
    this.personalInfoService.savePersonalInfo(data)
      .subscribe(response => {
        if (response !== null) {
          Swal.fire(
            'Done!',
            'Personal info saved!',
            'success'
          );
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'The personal info is already present. Please update',
          });
          this.router.navigate(['/dashboard/profile']);
        }
        // console.warn("==================== response :: ", response)
      })
  }

}
